import Vue from 'vue'
import App from './App.vue'
import router from './router/router'

// import ElementUI from 'element-ui'
//Vue.use(ElementUI)
// import {Progress,Dialog,Button} from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(Progress)
// Vue.use(Dialog)
// Vue.use(Button)

Vue.config.productionTip = false


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
